var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('w-button',_vm._g({attrs:{"rounded":_vm.rounded || _vm.circle,"size":_vm.size,"icon":_vm.icon,"icon-right":_vm.iconRight,"color":_vm.color,"disabled":!_vm.enabled,"loading":_vm.loading,"tooltip":_vm.$t('copyWeetButton.thumbnail.tooltip')},on:{"click":_vm.copyThumbnail}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }